module.exports = __webpack_public_path__ + "components/ski-hire-promo/static/ski-hire--background-f6851a8404cb9fdb40d1725c664db04c.webp";